import { render, staticRenderFns } from "./WapWXCW03View.vue?vue&type=template&id=2d47aa77&scoped=true&"
import script from "./WapWXCW03View.vue?vue&type=script&lang=js&"
export * from "./WapWXCW03View.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW03View.vue?vue&type=style&index=0&id=2d47aa77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47aa77",
  null
  
)

export default component.exports